// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/sicherungshalter/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSicherungshalterDE: PageEntry = {
  id: "example.produkte-sicherungshalter",
  locale: "de",
  slug: "produkte/sicherungshalter",
  seo: {
    title: "Sicherungshalter | Dietz GmbH",
    description: "Die Produktion von Sicherungshaltern in der Elektrotechnik umfasst die Herstellung von speziellen Halterungen für elektrische Sicherungen. Dies beinhaltet Materialauswahl, Formgebu",
  },
  type: "post",
  h1: "Sicherungshalter",
  intro: "Die Produktion von Sicherungshaltern in der Elektrotechnik umfasst die Herstellung von speziellen Halterungen für elektrische Sicherungen. Dies beinhaltet Materialauswahl, Formgebung, Anschlussmontage und Qualitätskontrolle, um Sicherheitsstandards einzuhalten und die Zuverlässigkeit zu gewährleisten.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_elektrotechnik.jpg", alt: "Elektrotechnik – Sicherungshalter komplett gefertigt von Dietz Neustadt bei Coburg", width: 700, height: 560 }
  ],
};
